import React from 'react'
import { Button, Input } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'

interface StaffEmailsInputProps {
  value?: string[]
  onChange?: (value: string[]) => void
  placeholder?: string
}

// Список почт с автодобавлением: как только заполнено последнее поле, снизу
// появляется пустое для следующего адреса
export const StaffEmailsInput: React.FC<StaffEmailsInputProps> = ({
  value = [],
  onChange,
  placeholder
}) => {
  const filled = value.length ? value : ['']
  const rows = filled[filled.length - 1].trim() ? [...filled, ''] : filled

  const setEmail = (index: number, email: string) => {
    const next = [...rows]
    next[index] = email
    onChange?.(next)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {rows.map((email, index) => {
        const isTrailingEmpty = index === rows.length - 1 && !email.trim()

        return (
          <div key={index} style={{ display: 'flex', gap: 8 }}>
            <Input
              value={email}
              placeholder={placeholder}
              onChange={(e) => setEmail(index, e.target.value)}
            />
            {!isTrailingEmpty && (
              <Button
                icon={<DeleteOutlined />}
                onClick={() => onChange?.(rows.filter((_, i) => i !== index))}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
